// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
  margin: 15px 20px;
}

.item-row {
  padding: 2px;
  height: 100%;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}
.item-row.inactive {
  opacity: 0.3;
}
.item-row.isAdded {
  border: 1px solid var(--color-black);
}

.article-img-wrapper {
  width: 100%;
  max-height: 230px;
  display: flex;
}
.article-img-wrapper img {
  clip-path: polygon(37px 0, 100% 0, 100% 100%, 0 100%, 0 37px);
  border-bottom: 1px solid var(--ion-color-grey);
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
.article-img-wrapper.block-adding img {
  opacity: 0.3;
}
.article-img-wrapper.block-adding ion-icon {
  position: absolute;
  top: 10px;
  right: -15px;
  transform: translate(-50%, -50%);
  z-index: 99;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}

.article-title {
  display: flex;
  width: 100%;
  margin: 20px 20px 10px;
}
.article-title .article-name {
  display: block;
  width: 80%;
  margin: 0;
  font-family: var(--ion-font-family);
}
.article-title .article-price {
  width: 20%;
}
.article-title .article-price .price {
  margin: 0 5px 0 auto;
  width: max-content;
  font-size: 20px;
  font-weight: 700;
  font-family: var(--ion-font-family);
}
.article-title .article-price .tags {
  width: max-content;
  margin-left: auto;
}

.article-info {
  margin: 0 20px 20px;
  color: var(--ion-color-text-gery);
}

.article-footer {
  width: 100%;
  margin: 0 20px 20px;
  display: flex;
}
.article-footer ion-button {
  transition: width 0.2s ease-in-out;
  width: 100%;
  padding: 0;
  --border-width: 0px;
  --border-style: none;
  font-family: var(--ion-font-family);
  text-transform: none;
  height: 40px;
}
.article-footer .quantity-regulator {
  width: 0;
  transition: width 0.2s ease-in-out;
  display: none;
  justify-content: space-around;
  align-items: center;
}
.article-footer .quantity-regulator img {
  height: 20px;
  width: 20px;
}

.article-footer.active {
  position: relative;
}
.article-footer.active .quantity-regulator {
  padding: 0 20px 0 10px;
  width: 50%;
  display: flex;
  height: 44px;
}
.article-footer.active ion-button {
  --background: var(--ion-color-black);
  width: 55%;
  color: var(--ion-color-white);
  position: absolute;
  right: 0px;
}

.article-footer.active-eintracht {
  position: relative;
}
.article-footer.active-eintracht .quantity-regulator {
  padding: 0 30px 0 15px;
  width: 50%;
  display: flex;
  height: 40px;
}
.article-footer.active-eintracht ion-button {
  --background: #E30613;
  border: 1px solid #E30613;
  border-radius: 6px;
  width: 55%;
  color: #fff;
  position: absolute;
  right: 0px;
}

.cut-card {
  border: none;
  background-color: transparent;
  position: relative;
  clip-path: polygon(var(--size-skew) 0, 100% 0, 100% calc(100% - var(--size-skew)), calc(100% - var(--size-skew)) 100%, 0 100%, 0 var(--size-skew));
  box-sizing: border-box;
}
.cut-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background-color: #d2d2d2;
  clip-path: polygon(0 var(--size-skew), var(--size-skew) 0, 100% 0, 100% calc(100% - var(--size-skew)), calc(100% - var(--size-skew)) 100%, 0 100%, 0 var(--size-skew), 2px calc(var(--size-skew) + 0.83px), 2px calc(100% - 2px), calc(100% - var(--size-skew) - 0.83px) calc(100% - 2px), calc(100% - 2px) calc(100% - var(--size-skew) - 0.83px), calc(100% - 2px) 2px, calc(var(--size-skew) + 0.83px) 2px, 2px calc(var(--size-skew) + 0.83px));
  pointer-events: none;
}

.dark-theme-card {
  border: 1px solid #383838;
  border-radius: 6px;
  padding: 0;
}
.dark-theme-card .article-img-wrapper img {
  border-bottom: none;
  background: radial-gradient(100% 276.77% at 0% 54.77%, rgba(18, 18, 18, 0) 0%, #121212 50%, rgba(18, 18, 18, 0) 100%);
}

.quantity {
  font-size: 20px;
  font-family: var(--ion-font-family);
  font-weight: 700;
  padding-top: 5px;
}

.article-desc {
  display: contents;
}

.eintracht {
  display: block;
  background: #383838;
}
.eintracht .article-title, .eintracht .article-footer {
  width: auto;
  font-family: EintrachtDisplaySublineCondensed;
  gap: 10px;
}
.eintracht .article-title ion-button, .eintracht .article-footer ion-button {
  height: 40px;
  min-height: 40px;
  margin: 0;
  font-family: AppFontEintrachtOFCSans;
  font-size: 14px;
  line-height: 130%;
}
.eintracht .article-name {
  font-family: EintrachtDisplaySublineCondensed;
  font-weight: 400;
  font-size: 20px;
  line-height: 110%;
}
.eintracht .article-price .price {
  font-family: EintrachtDisplaySublineCondensed;
  font-weight: 400;
  font-size: 20px;
  line-height: 110%;
}
.eintracht .article-info {
  color: #D6D6D6;
  font-family: AppFontEintrachtOFCSans, sans-serif;
  font-weight: 400;
  line-height: 130%;
}
.eintracht .amex-offer {
  width: auto;
  margin: 0 20px 12px;
}

@media (min-width: 991px) {
  :host {
    margin: 0;
  }
}
.btn.btn-outline .to-basket-text {
  padding-top: 4px;
}

ion-button[disabled] {
  opacity: 1;
  cursor: not-allowed;
}

.new {
  background: #000000;
  color: #FFFFFF;
  height: -moz-fit-content;
  height: fit-content;
  padding: 10px 12px;
  position: absolute;
  clip-path: polygon(15px 0, 100% 0, 100% 100%, 0 100%, 0 15px);
}
.new h4 {
  font-weight: 700;
  font-size: 13px;
  line-height: 131%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
}

.dark-theme-card .new {
  background: #383838;
  border: 1px solid #383838;
  color: #FFFFFF;
  height: -moz-fit-content;
  height: fit-content;
  padding: 10px 12px;
  position: absolute;
  clip-path: border-box;
  border-bottom-right-radius: 9px;
  z-index: 1;
}
.dark-theme-card .new h4 {
  font-family: EintrachtDisplaySublineCondensed;
  font-weight: 500;
  font-size: 20px;
  line-height: 110%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,YAAA;EACA,iBAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EAEA,kBAAA;EAIA,eAAA;AALF;AAOE;EACE,YAAA;AALJ;AAQE;EACE,oCAAA;AANJ;;AAUA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;AAPF;AASE;EACE,6DAAA;EACA,8CAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAPJ;AAWI;EACE,YAAA;AATN;AAYI;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EACA,gCAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAVN;;AAeA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;AAZF;AAcE;EACE,cAAA;EAEA,UAAA;EACA,SAAA;EACA,mCAAA;AAbJ;AAgBE;EAEE,UAAA;AAfJ;AAiBI;EACE,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mCAAA;AAfN;AAkBI;EACE,kBAAA;EACA,iBAAA;AAhBN;;AAqBA;EACE,mBAAA;EACA,iCAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;AAlBF;AAoBE;EACE,kCAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,oBAAA;EACA,mCAAA;EACA,oBAAA;EACA,YAAA;AAlBJ;AAqBE;EACE,QAAA;EACA,kCAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,YAAA;EACA,WAAA;AAnBN;;AAwBA;EACE,kBAAA;AArBF;AAuBE;EAEE,sBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;AAtBJ;AAyBE;EACE,oCAAA;EACA,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;AAvBJ;;AA2BA;EACE,kBAAA;AAxBF;AA0BE;EACE,sBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;AAxBJ;AA2BE;EACE,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAzBJ;;AA8BA;EACE,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,kJAAA;EACA,sBAAA;AA3BF;AA6BE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,mbAAA;EACA,oBAAA;AA3BJ;;AA+BA;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;AA5BF;AA+BI;EACE,mBAAA;EACA,qHAAA;AA7BN;;AAkCA;EACE,eAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;AA/BF;;AAiCA;EACE,iBAAA;AA9BF;;AAgCA;EACE,cAAA;EACA,mBAAA;AA7BF;AA8BE;EACE,WAAA;EACA,6CAAA;EACA,SAAA;AA5BJ;AA6BI;EACE,YAAA;EACA,gBAAA;EACA,SAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;AA3BN;AA+BE;EACE,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7BJ;AAgCI;EACE,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA9BN;AAiCE;EACE,cAAA;EACA,gDAAA;EACA,gBAAA;EACA,iBAAA;AA/BJ;AAiCE;EACE,WAAA;EACA,mBAAA;AA/BJ;;ACvNE;ED0PA;IACG,SAAA;EA/BH;AACF;AAmCI;EACE,gBAAA;AAjCN;;AAqCA;EACE,UAAA;EACA,mBAAA;AAlCF;;AAoCA;EACE,mBAAA;EACA,cAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6DAAA;AAjCF;AAkCI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AAhCN;;AAoCE;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;AAjCF;AAkCI;EACE,6CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAhCN","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n  display: block;\n  height: 100%;\n  margin: 15px 20px;\n}\n\n.item-row {\n  padding: 2px;\n  height: 100%;\n  overflow: hidden;\n  // border-radius: 10px;\n  position: relative;\n  // transition: border 0.2s ease-in-out;\n  // background: var(--ion-color-white);\n  // border: 1px solid  var(--ion-color-grey);\n  cursor: pointer;\n\n  &.inactive {\n    opacity: 0.3;\n  }\n\n  &.isAdded {\n    border: 1px solid var(--color-black);\n  }\n}\n\n.article-img-wrapper {\n  width: 100%;\n  max-height: 230px;\n  display: flex;\n\n  img {\n    clip-path: polygon(37px 0, 100% 0, 100% 100%, 0 100%, 0 37px);\n    border-bottom: 1px solid var(--ion-color-grey);\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center;\n  }\n\n  &.block-adding {\n    img {\n      opacity: 0.3;\n    }\n\n    ion-icon {\n      position: absolute;\n      top: 10px;\n      right: -15px;\n      transform: translate(-50%, -50%);\n      z-index: 99;\n      width: 25px;\n      height: 25px;\n      opacity: 0.3;\n    }\n  }\n}\n\n.article-title {\n  display: flex;\n  width: 100%;\n  margin: 20px 20px 10px;\n\n  .article-name {\n    display: block;\n    // width: 60%;\n    width: 80%;\n    margin: 0;\n    font-family: var(--ion-font-family);\n  }\n\n  .article-price {\n    // width: 40%;\n    width: 20%;\n\n    .price {\n      margin: 0 5px 0 auto;\n      width: max-content;\n      font-size: 20px;\n      font-weight: 700;\n      font-family: var(--ion-font-family);\n    }\n\n    .tags {\n      width: max-content;\n      margin-left: auto;\n    }\n  }\n}\n\n.article-info {\n  margin: 0 20px 20px;\n  color: var(--ion-color-text-gery);\n}\n\n.article-footer {\n  width: 100%;\n  margin: 0 20px 20px;\n  display: flex;\n  // border: 1px solid var(--ion-color-black);\n  ion-button {\n    transition: width 0.2s ease-in-out;\n    width: 100%;\n    padding: 0;\n    --border-width: 0px;\n    --border-style: none;\n    font-family: var(--ion-font-family);\n    text-transform: none;\n    height: 40px;\n  }\n\n  .quantity-regulator {\n    width: 0;\n    transition: width 0.2s ease-in-out;\n    display: none;\n    justify-content: space-around;\n    align-items: center;\n\n    img {\n      height: 20px;\n      width: 20px;\n    }\n  }\n}\n\n.article-footer.active {\n  position: relative;\n\n  .quantity-regulator {\n    // padding: 0 15px 0 15px;\n    padding: 0 20px 0 10px;\n    width: 50%;\n    display: flex;\n    height: 44px;\n  }\n\n  ion-button {\n    --background: var(--ion-color-black);\n    width: 55%;\n    color: var(--ion-color-white);\n    position: absolute;\n    right: 0px;\n  }\n}\n\n.article-footer.active-eintracht {\n  position: relative;\n\n  .quantity-regulator {\n    padding: 0 30px 0 15px;\n    width: 50%;\n    display: flex;\n    height: 40px;\n  }\n\n  ion-button {\n    --background: #E30613;\n    border: 1px solid #E30613;\n    border-radius: 6px;\n    width: 55%;\n    color: #fff;\n    position: absolute;\n    right: 0px;\n  }\n}\n\n// cards block styles\n.cut-card {\n  border: none;\n  background-color: transparent;\n  position: relative;\n  clip-path: polygon(var(--size-skew) 0, 100% 0, 100% calc(100% - var(--size-skew)), calc(100% - var(--size-skew)) 100%, 0 100%, 0 var(--size-skew));\n  box-sizing: border-box;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background-color: #d2d2d2;\n    clip-path: polygon(0 var(--size-skew), var(--size-skew) 0, 100% 0, 100% calc(100% - var(--size-skew)), calc(100% - var(--size-skew)) 100%, 0 100%, 0 var(--size-skew), 2px calc(var(--size-skew) + 0.83px), 2px calc(100% - 2px), calc(100% - var(--size-skew) - 0.83px) calc(100% - 2px), calc(100% - 2px) calc(100% - var(--size-skew) - 0.83px), calc(100% - 2px) 2px, calc(var(--size-skew) + 0.83px) 2px, 2px calc(var(--size-skew) + 0.83px));\n    pointer-events: none;\n  }\n}\n\n.dark-theme-card {\n  border: 1px solid #383838;\n  border-radius: 6px;\n  padding: 0;\n\n  .article-img-wrapper {\n    img {\n      border-bottom: none;\n      background: radial-gradient(100% 276.77% at 0% 54.77%, rgba(18, 18, 18, 0) 0%, #121212 50%, rgba(18, 18, 18, 0) 100%);\n    }\n  }\n}\n\n.quantity {\n  font-size: 20px;\n  font-family: var(--ion-font-family);\n  font-weight: 700;\n  padding-top: 5px;\n}\n.article-desc {\n  display: contents;\n}\n.eintracht {\n  display: block;\n  background: #383838;\n  .article-title, .article-footer {\n    width: auto;\n    font-family: EintrachtDisplaySublineCondensed;\n    gap: 10px;\n    ion-button {\n      height: 40px;\n      min-height: 40px;\n      margin: 0;\n      font-family: AppFontEintrachtOFCSans;\n      font-size: 14px;\n      line-height: 130%;\n    }\n  }\n  // Figma: Eintracht Display VF, weight 50 = the Subline Condensed instance\n  .article-name {\n    font-family: EintrachtDisplaySublineCondensed;\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 110%;\n  }\n  .article-price {\n    .price {\n      font-family: EintrachtDisplaySublineCondensed;\n      font-weight: 400;\n      font-size: 20px;\n      line-height: 110%;\n    }\n  }\n  .article-info {\n    color: #D6D6D6;\n    font-family: AppFontEintrachtOFCSans, sans-serif;\n    font-weight: 400;\n    line-height: 130%;\n  }\n  .amex-offer {\n    width: auto;\n    margin: 0 20px 12px;\n  }\n}\n@include desktop {\n  :host {\n     margin: 0;\n  }\n}\n.btn {\n  &.btn-outline {\n    .to-basket-text {\n      padding-top: 4px;\n    }\n  }\n}\nion-button[disabled] {\n  opacity: 1;\n  cursor: not-allowed; \n}\n.new {\n  background: #000000;\n  color: #FFFFFF;\n  height: fit-content;\n  padding: 10px 12px;\n  position: absolute;\n  clip-path: polygon(15px 0, 100% 0, 100% 100%, 0 100%, 0 15px);\n    h4 {\n      font-weight: 700;\n      font-size: 13px;\n      line-height: 131%;\n      letter-spacing: 0%;\n      text-align: center;\n      vertical-align: middle;\n      text-transform: capitalize;\n    }\n}\n.dark-theme-card {\n  .new {\n  background: #383838;\n  border: 1px solid #383838;\n  color: #FFFFFF;\n  height: fit-content;\n  padding: 10px 12px;\n  position: absolute;\n  clip-path: border-box;\n  border-bottom-right-radius: 9px;\n  z-index: 1;\n    h4 {\n      font-family: EintrachtDisplaySublineCondensed;\n      font-weight: 500;\n      font-size: 20px;\n      line-height: 110.00000000000001%;\n      letter-spacing: 0%;\n      vertical-align: middle;\n      text-transform: uppercase;\n    }\n}\n}","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
